export const NAMES_PATTERN = /^[a-zA-Z\s'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙâêôãõçÂÊÔÃÕÇüñÜÑ]{2,}$/g

export const OBJECTS_NAMES_PATTERN = /^[a-zA-Z\s'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙâêôãõçÂÊÔÃÕÇüñÜÑ\d]{2,}$/g

export const EMAIL_PATTERN = /^[a-zA-Z0-9_!#$%&’*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+[.]{1,1}[a-zA-Z0-9]{2,}$/g

export const PHONE_NUMBER_PATTERN = /^(\+\d{1,3}( )?)?((\(\d{3}\))|\d{3})[- .]?\d{3}[- .]?\d{4}$|^(\+\d{1,3}( )?)?(\d{3}[ ]?){2}\d{3}$|^(\+\d{1,3}( )?)?(\d{3}[ ]?)(\d{2}[ ]?){2}\d{2}$/g

export const P_IVA_PATTERN = /^(IT)?[0-9]{11}$/g

export const CITY_NAME_PATTERN = /^([\w'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙ]+(\s)*)+ \(\w{2}\)$/g

export const STREET_ADDRES_PATTERN  = /^[\w'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙ]+([\s|'][\w|\w,\w°|\w\\|\w/|\w\-|\w'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙ]+){2,}(\s(\d){5}\s\w+)?\s?(\(\w{2}\))?(,\s(Italia|ITALIA))?$/g

export const STREET_NAME_PATTERN = /^([\w'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙ]{2,} [\w'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙ0-9 '°]{2,})$/g

export const STREET_NUMBER_PATTERN = /^\d{1,3}([\\/-]{1}\w)?/g

export const DEVICES_PATTERN = /^((\w\s|\w)+(;)*)+$/g

export const STRONG_PASS_PATTERN = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/g

export const NUMBER_PATTERN = /^\d+((,|.)\d{1,2}){0,1}$/g

export const PATTERN_TARGA_AUTO_VECCHIA = /^(AG|AL|AN|AO|AP|AQ|AR|AT|AV|BA|BG|BI|BL|BN|BO|BR|BS|BT|BZ|CA|CB|CE|CH|CI|CL|CN|CO|CR|CS|CT|CZ|EN|FC|FE|FG|FI|FM|FO|FR|GE|GO|GR|IM|IS|KR|LC|LE|LI|LO|LT|LU|MB|MC|ME|MI|MN|MO|MS|MT|NA|NO|NU|OG|OR|OT|PA|PC|PD|PE|PG|PI|PN|PO|PR|PS|PT|PU|PV|PZ|RA|RC|RE|RG|RI|RM|RN|RO|SA|SI|SO|SP|SR|SS|SV|TA|TE|TN|TO|TP|TR|TS|TV|UD|VA|VB|VC|VE|VI|VR|VS|VT|VV|ROMA)(?:(?![CIJOQcijoq])[a-zA-Z0-9]){5,6}$/g
export const PATTERN_TARGA_AUTO_NUOVA = /^(?:(?![IOQUioqu])[a-zA-Z]){2}[0-9]{3}(?:(?![IOQUioqu])[a-zA-Z]){2}$/g

export const PATTERN_TARGA_MOTO_VECCHIA = /^(AG|AL|AN|AO|AP|AQ|AR|AT|AV|BA|BG|BI|BL|BN|BO|BR|BS|BT|BZ|CA|CB|CE|CH|CI|CL|CN|CO|CR|CS|CT|CZ|EN|FC|FE|FG|FI|FM|FO|FR|GE|GO|GR|IM|IS|KR|LC|LE|LI|LO|LT|LU|MB|MC|ME|MI|MN|MO|MS|MT|NA|NO|NU|OG|OR|OT|PA|PC|PD|PE|PG|PI|PN|PO|PR|PS|PT|PU|PV|PZ|RA|RC|RE|RG|RI|RM|RN|RO|SA|SI|SO|SP|SR|SS|SV|TA|TE|TN|TO|TP|TR|TS|TV|UD|VA|VB|VC|VE|VI|VR|VS|VT|VV|ROMA)(?:(?![CIJOQcijoq])[a-zA-Z0-9]){5,6}$/g
export const PATTERN_TARGA_MOTO_NUOVA = /^(?:(?![IOQUioqu])[a-zA-Z]){2}[0-9]{5}$/g

// @see https://it.wikipedia.org/wiki/Targhe_d%27immatricolazione_dell%27Italia#Ciclomotori
export const PATTERN_TARGA_50CC = /^((?![aeioquAEIOQU01_])\w){6}$/g

export function isEmpty (val: string | undefined) {
    return (val === undefined || val === null || val === '' || val === 'Seleziona')
}

export function isValid (val : string | undefined, regexp: RegExp) {
    if ( isEmpty(val) ) {
        return false
    }

    const pattern: any = new RegExp(regexp)

    return pattern.test(val)
}

export function isValidTarga (targa: string | undefined, tipologiaVeicolo: number | undefined) {
    if (tipologiaVeicolo === undefined ) {
            return true
        }
        else {
            switch (Number(tipologiaVeicolo) || 0) {
                case 1: // Auto
                case 3: // Autocarro
                    return (isValid(targa?.toUpperCase(), PATTERN_TARGA_AUTO_VECCHIA) || isValid(targa?.toUpperCase(), PATTERN_TARGA_AUTO_NUOVA))
                case 2: // Moto
                    return (isValid(targa?.toUpperCase(), PATTERN_TARGA_MOTO_VECCHIA) || isValid(targa?.toUpperCase(), PATTERN_TARGA_MOTO_NUOVA))
                case 4: // Ciclomotore
                    return isValid(targa?.toUpperCase(), PATTERN_TARGA_50CC)
                default:
                    return false
            }
        }
}

export function isValidCityName (city: any) {
    return isValid ((city as string), CITY_NAME_PATTERN)
}

export function getMicrocarTypologyFromPlate (targa: string | undefined) {
    if (isValid(targa?.toUpperCase(), PATTERN_TARGA_MOTO_VECCHIA) || isValid(targa?.toUpperCase(), PATTERN_TARGA_MOTO_NUOVA)) {
        return 'quadriciclo'
    }
    if (isValid(targa?.toUpperCase(), PATTERN_TARGA_50CC)) {
        return 'microcar'
    }
    return undefined
}